import { Button } from "@mui/material";
import { SpaceAccess } from "../types";

export type ManagePermissionsCellProps = {
  space: SpaceAccess;
  onManageAccess: (space: SpaceAccess) => void;
};

export function ManagePermissionsCell({
  space,
  onManageAccess,
}: ManagePermissionsCellProps) {
  return (
    <Button
      variant="contained"
      size="small"
      sx={{ color: "text.secondary" }}
      disableElevation
      onClick={(e) => {
        e.stopPropagation();
        onManageAccess(space);
      }}
    >
      Manage Access
    </Button>
  );
}
